import { useTranslation } from 'react-i18next';

const FEATURES = [
  { color: 'from-emerald-500 via-teal-500 to-cyan-500', icon: 'ri-shield-check-line', titleKey: 'whydigi.f1_title', descKey: 'whydigi.f1_desc' },
  { color: 'from-amber-400 via-yellow-500 to-orange-500', icon: 'ri-flashlight-line', titleKey: 'whydigi.f2_title', descKey: 'whydigi.f2_desc' },
  { color: 'from-pink-500 via-[#862ce0] to-[#c026d3]', icon: 'ri-customer-service-2-line', titleKey: 'whydigi.f3_title', descKey: 'whydigi.f3_desc' },
  { color: 'from-cyan-500 via-blue-500 to-indigo-600', icon: 'ri-replay-10-line', titleKey: 'whydigi.f4_title', descKey: 'whydigi.f4_desc' },
  { color: 'from-violet-500 via-purple-500 to-fuchsia-500', icon: 'ri-refresh-line', titleKey: 'whydigi.f5_title', descKey: 'whydigi.f5_desc' },
  { color: 'from-green-500 via-emerald-500 to-teal-500', icon: 'ri-anti-spam-2-line', titleKey: 'whydigi.f6_title', descKey: 'whydigi.f6_desc' },
  { color: 'from-orange-500 via-[#862ce0] to-pink-500', icon: 'ri-4k-line', titleKey: 'whydigi.f7_title', descKey: 'whydigi.f7_desc' },
];

export default function WhyDigicode() {
  const { t } = useTranslation();
  return (
    <section id="avantages" className="py-12 sm:py-16 md:py-20 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">{t('whydigi.title')}</h2>
          <p className="text-base sm:text-lg text-gray-400 max-w-3xl mx-auto">{t('whydigi.desc')}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {FEATURES.map(({ color, icon, titleKey, descKey }) => (
            <div key={titleKey} className="bg-gray-900/50 border border-gray-800 hover:border-gray-600 transition-all duration-300 hover:scale-105 rounded-lg group">
              <div className="p-5 sm:p-6 text-center">
                <div className={`bg-gradient-to-r ${color} w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-all duration-300`}>
                  <i className={`${icon} text-white text-2xl`} />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-white mb-2 group-hover:text-primary transition-colors">{t(titleKey)}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{t(descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
